import { getRequiredCores } from "./index17.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel } from "@project-rouge/rg-three";
function validateCoreRegulations(building, dataset, log) {
	const { requiredFireLifts, requiredNonFireLifts, requiredStairs } = getRequiredCores(building.data.anatomy, dataset);
	const allCores = getRgObjectsAtLevel(building, RG_TYPE.Core, 0);
	const fireCoreCount = allCores.filter((c) => c.data.hasFireLift).length;
	const nonFireCoreCount = allCores.filter((c) => c.data.hasNonFireLift).length;
	const stairCoreCount = allCores.filter((c) => !c.data.hasNonFireLift && !c.data.hasFireLift).length;
	if (allCores.length !== fireCoreCount + nonFireCoreCount + stairCoreCount) {
		log && console.log("total core count not equal to sum of individual cores");
		return false;
	}
	if (fireCoreCount < requiredFireLifts) {
		log && console.log("not enough fire lift cores");
		return false;
	}
	if (nonFireCoreCount < requiredNonFireLifts) {
		log && console.log("not enough non fire lift cores");
		return false;
	}
	if (stairCoreCount < requiredStairs) {
		log && console.log("not enough stair cores");
		return false;
	}
	return true;
}
export { validateCoreRegulations };

//# sourceMappingURL=index186.js.map